module.exports = __webpack_public_path__ + "static/PFB_INTRO_IMAGES_03-df92a67329efc82c2f79cdd57badf03a.jpg";